import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from "../../../../middlewares/api/actions";
import {
    MAPPING_SET_DESELECT_DATASET,
    MAPPING_SET_FORCE_TREE_REFRESH,
    MAPPING_SET_GET_DATASETS,
    MAPPING_SET_GET_DDB_CONNECTIONS,
    MAPPING_SET_GET_DSD_INFO,
    MAPPING_SET_RESET_FIELDS,
    MAPPING_SET_SELECT_CONNECTION,
    MAPPING_SET_SELECT_DATASET,
    MAPPING_SET_UPDATE_FIELDS,
    MAPPING_SET_WIZARD_COLUMN_SELECT,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT,
    MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_STASH,
    MAPPING_SET_WIZARD_DELETE_STASH_ROW,
    MAPPING_SET_WIZARD_DSD_COLUMN_SELECT,
    MAPPING_SET_WIZARD_GET_MAPPING_SET,
    MAPPING_SET_WIZARD_GET_MAPPING_TOKEN,
    MAPPING_SET_WIZARD_QUERY_PREVIEW_COLUMN_ROWS_READ,
    MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ,
    MAPPING_SET_WIZARD_RESET_SAVE_STATUS,
    MAPPING_SET_WIZARD_RESET_VALIDATIONS,
    MAPPING_SET_WIZARD_SAVE_MAPPING_SET,
    MAPPING_SET_CHECK_STRUVAL,
    MAPPING_SET_WIZARD_VALIDATE_MAPPING,
    MAPPING_SET_WIZARD_VALIDATE_DATA,
    MAPPING_SET_WIZARD_VALIDATE_DATASET,
    MAPPING_SET_WIZARD_VALIDATE_FORMAT_STATUS_ON_EXIT_CLEAR,
    MAPPING_SET_WIZARD_VALIDATE_FORMAT,
    MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW,
    MAPPING_SET_WIZARD_CLEAR_UPDATE_PREVIEW_FLAG, MAPPING_SET_WIZARD_CLEAR_MAPPING_SET_PREVIEW,
    MAPPING_SET_WIZARD_HIDE,
} from "./actions";
import _ from "lodash";
import { adjustRowsObject } from "../../dataset-builder/utils";
import { mappingTypeDefault, mappingTypeFixed } from "../../../data-manager/file-mapping/wizard/utils";
import { prepareMappingSetObject, prepareMappingsForTable } from "./utils";
import { MAPPING_SET_WIZARD_DELETE_MAPPING_SET } from "../mapping-set-tree/actions";
import {
    TRANSCODING_SETTINGS_SAVE_DIMENSION, 
    TRANSCODING_SIMPLE_VALUE_SUBMIT,
    TRANSCODING_SETTINGS_DELETE_DIMENSION
} from "../transcoding/actions";

const initialState = {
    selectedConnection: null,
    selectedDataset: null,
    selectedMappingSet: null,
    connections: null,
    datasets: null,
    name: null,
    description: null,
    rows: null,
    colRows: null,
    selectedColumnName: null,
    selectedDsdColumnName: null,
    dsd: null,
    dsdTriplet: null,
    components: null,
    selectedMapping: null,
    stash: null,
    mappingSetPreview: null,
    mappingSetPreviewToken: null,
    updatePreview: false,
    noMoreResults: false,
    validateDataStatus: null,
    validateDatasetStatus: null,
    validateMappingStatus: null,
    validateFormatStatus: null,
    validateStatusOnExit: null,
    saveSuccessful: false,
    saveValidationSuccessful: false,
    closeValidation: false,
    isStruvalPresent: false,
    showMappingAlert: false
}

const mappingSetWizardReducer = (state = initialState, action) => {
    switch (action.type) {
        case MAPPING_SET_WIZARD_HIDE: 
            return {...state,selectedMappingSet: null};
        case MAPPING_SET_WIZARD_CLEAR_UPDATE_PREVIEW_FLAG:
            return {...state, updatePreview: false};
        case MAPPING_SET_WIZARD_VALIDATE_FORMAT_STATUS_ON_EXIT_CLEAR:
            return {...state, validateStatusOnExit: null};
        case MAPPING_SET_WIZARD_RESET_VALIDATIONS:
            return { ...state, validateDataStatus: null, validateFormatStatus: null, validateDatasetStatus: null, validateMappingStatus: null, closeValidation: false };
        case MAPPING_SET_WIZARD_RESET_SAVE_STATUS:
            if (action.forValidation) return { ...state, saveValidationSuccessful: false }
            return { ...state, saveSuccessful: false };
        case MAPPING_SET_FORCE_TREE_REFRESH:
            return { ...state, saveSuccessful: true };
        case MAPPING_SET_WIZARD_DELETE_STASH_ROW:
            const modStash = [...state.stash];
            const stashToDeleteIdx = modStash.findIndex(item => item.dsdColumnName === action.row.dsdColumnName);
            modStash.splice(stashToDeleteIdx, 1);
            return {
                ...state, stash: modStash
            }
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_STASH: {
            return {
                ...state,
                stash: [...(state.stash || []), ...(state.components || []).map(item => ({
                    ...item,
                    columnName: (item.columnName || []).join(", "),
                    status: ""
                }))],
                components: null
            }
        }
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD: {
            const typeDsdColumn = state.dsd.find(e => e.id === state.selectedDsdColumnName) || null
            if(action.singleColumn && typeDsdColumn.type === "TimeDimension" && state.selectedColumnName.length > 1) {
                return {
                    ...state,
                    showMappingAlert: true,
                }
            } else {
                if (!!action.constantValue) {
                    const selectedMapping = {
                        columnObj: [],
                        columnName: state.selectedColumnName || "",
                        dsdColumnName: state.selectedDsdColumnName || "",
                        dsdType: typeDsdColumn.type || null,
                        mappingType: mappingTypeFixed,
                        constantValue: action.constantValue,
                    };
                    return {
                        ...state,
                        selectedMapping: selectedMapping,
                        selectedColumnName: null,
                        selectedDsdColumnName: null,
                        components: [
                            ...(state.components || []),
                            selectedMapping
                        ],
                    };
                }
                const colObj = (state.selectedColumnName || [""]).map(colName => state.selectedDataset.columns.find(col => col.name === colName) || {});

                const selectedMapping = {
                    columnObj: colObj || [],
                    columnName: state.selectedColumnName || "",
                    dsdColumnName: state.selectedDsdColumnName || "",
                    dsdType: typeDsdColumn.type || null,
                    mappingType: mappingTypeDefault
                };
                return {
                    ...state,
                    selectedMapping: selectedMapping,
                    selectedColumnName: null,
                    selectedDsdColumnName: null,
                    components: [
                        ...(state.components || []),
                        selectedMapping
                    ],
                };
            }
        }
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_ADD_ALL:
            const componentCanBeMapped = (dsdColumnName) => {
                return (state.components || [])
                    .map(mapping => mapping.dsdColumnName)
                    .indexOf(dsdColumnName) === -1;
            }
            const components = [
                ...(state.selectedDataset.columns || [])
                    .filter(columnNameToBeMapped =>
                        !_.flatten(([...(state.components || []), ...(state.stash || [])]).map(comp => comp.columnName)).includes(columnNameToBeMapped.name || columnNameToBeMapped.columnName))
                    .map(columnNameToBeMapped => {
                        const relatedDsdComponents =
                            state.dsd.map(dsdObj => dsdObj.id)
                                .find(dsdComp =>
                                    dsdComp === (columnNameToBeMapped.name || columnNameToBeMapped.columnName) &&
                                    componentCanBeMapped(dsdComp));

                        return relatedDsdComponents
                            ? {
                                columnObj: columnNameToBeMapped,
                                columnName: [columnNameToBeMapped.name],
                                dsdColumnName: relatedDsdComponents,
                                mappingType: mappingTypeDefault
                            }
                            : null;
                    })
                    .filter(comp => comp !== null),
                ...(state.components || [])
            ];
            return {
                ...state,
                components: components,
                selectedColumnName: null,
                selectedDsdColumnName: null,
                selectedMapping: components.length > 0? components[0] : null,
            };
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE:
            return {
                ...state,
                components:
                    (state.components || [])
                        .filter(({ columnName, dsdColumnName }) =>
                            columnName !== action.columnName || dsdColumnName !== action.dsdColumnName)
                        .map(comp => ({ ...comp }))
            };
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_REMOVE_ALL:
            return {
                ...state,
                components: [],
                selectedMapping: null,
            };
        case MAPPING_SET_WIZARD_COMPONENT_MAPPER_COMPONENT_SELECT: {
            const selectedMapping = (state.components || []).find(comp =>
                comp.columnName === action.mapping.columnName &&
                comp.dsdColumnName === action.mapping.dsdColumnName);
            return {
                ...state,
                selectedColumnName: null,
                selectedCubeComponentCode: null,
                selectedMapping: selectedMapping,
            };
        }
        case MAPPING_SET_WIZARD_DSD_COLUMN_SELECT:
            if (action.columnName === state.selectedDsdColumnName)
                return {
                    ...state,
                    selectedDsdColumnName: null,
                };
            if (!action.multiplesAllowed)
                return {
                    ...state,
                    selectedDsdColumnName: action.columnName,
                };
            const newSelectedDsdColumns = [...(state.selectedDsdColumnName || [])];
            if (!newSelectedDsdColumns.includes(action.columnName))
                return {
                    ...state,
                    selectedDsdColumnName: [...newSelectedDsdColumns, action.columnName],
                };
            const newSelectedDsdColumnIdx = newSelectedDsdColumns.findIndex(col => col === action.columnName);
            newSelectedDsdColumns.splice(newSelectedDsdColumnIdx, 1);
            return {
                ...state,
                selectedDsdColumnName: newSelectedDsdColumns,
            };
        case MAPPING_SET_WIZARD_COLUMN_SELECT:
            if (!action.multiplesAllowed)
                return {
                    ...state,
                    selectedColumnName: action.columnName,
                };
            const newSelectedColumns = [...(state.selectedColumnName || [])];
            if (!newSelectedColumns.includes(action.columnName))
                return {
                    ...state,
                    selectedColumnName: [...newSelectedColumns, action.columnName],
                };
            const newSelectedColumnIdx = newSelectedColumns.findIndex(col => col === action.columnName);
            newSelectedColumns.splice(newSelectedColumnIdx, 1);
            return {
                ...state,
                selectedColumnName: newSelectedColumns,
            };
        case MAPPING_SET_DESELECT_DATASET:
            return { ...state, selectedDataset: null }
        case MAPPING_SET_RESET_FIELDS:
            return {...initialState, isStruvalPresent: state.isStruvalPresent};
        case MAPPING_SET_UPDATE_FIELDS:
            return { ...state, ..._.mapValues(action.fields, field => field.value) };
        case MAPPING_SET_SELECT_CONNECTION:
            return { ...state, selectedConnection: action.selectedConnection,
                selectedDataset: null,
                stash: action.shouldEraseStash ? null : state.stash,
                components: action.shouldEraseStash ? null : state.components,
                selectedMapping: action.shouldEraseStash ? null : state.selectedMapping,
                selectedColumnName: action.shouldEraseStash ? null : state.selectedColumnName,
                selectedDsdColumnName: action.shouldEraseStash ? null : state.selectedDsdColumnName,
            }
        case REQUEST_START:
            switch (action.label) {
                case MAPPING_SET_WIZARD_DELETE_MAPPING_SET:
                    return { ...state, saveSuccessful: false }
                case MAPPING_SET_WIZARD_SAVE_MAPPING_SET:
                    return { ...state, saveSuccessful: false, saveValidationSuccessful: false }
                case TRANSCODING_SETTINGS_SAVE_DIMENSION:
                    return {
                        ...state
                    }
                default:
                    return state;
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case MAPPING_SET_WIZARD_DELETE_MAPPING_SET:
                    return { ...state, saveSuccessful: false }
                case MAPPING_SET_WIZARD_SAVE_MAPPING_SET:
                    return { ...state, saveSuccessful: false, saveValidationSuccessful: false, closeValidation: true }
                case MAPPING_SET_WIZARD_VALIDATE_FORMAT:
                    return {...state, saveSuccessful: false, saveValidationSuccessful: false, closeValidation: true, validateFormatStatus: null}
                case MAPPING_SET_WIZARD_VALIDATE_MAPPING:
                    return {...state, saveSuccessful: false, saveValidationSuccessful: false, closeValidation: true, validateMappingStatus: null}
                case MAPPING_SET_WIZARD_VALIDATE_DATA:
                    return {...state, saveSuccessful: false, saveValidationSuccessful: false, closeValidation: true, validateDataStatus: null}
                case MAPPING_SET_WIZARD_VALIDATE_DATASET:
                    return {...state, saveSuccessful: false, saveValidationSuccessful: false, closeValidation: true, validateDatasetStatus: null}
                case MAPPING_SET_GET_DSD_INFO:
                    return { ...state, dsd: null, dsdTriplet: null };
                case MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ:
                    return { ...state, rows: null }
                case MAPPING_SET_GET_DDB_CONNECTIONS:
                    return { ...state, connections: null };
                case MAPPING_SET_GET_DATASETS:
                    return { ...state, datasets: null };
                case MAPPING_SET_SELECT_DATASET:
                    return { ...state, selectedDataset: null,
                        stash: action.shouldEraseStash ? null : state.stash,
                        components: action.shouldEraseStash ? null : state.components,
                        selectedMapping: action.shouldEraseStash ? null : state.selectedMapping,
                        selectedColumnName: action.shouldEraseStash ? null : state.selectedColumnName,
                        selectedDsdColumnName: action.shouldEraseStash ? null : state.selectedDsdColumnName, }
                case MAPPING_SET_WIZARD_GET_MAPPING_SET:
                    return { ...state, selectedMappingSet: null }
                case MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW:
                    return { ...state, updatePreview: false, noMoreResults: true }
                case MAPPING_SET_WIZARD_GET_MAPPING_TOKEN:
                    return { ...state, updatePreview: false, noMoreResults: true }
                case TRANSCODING_SETTINGS_SAVE_DIMENSION:
                    return {
                        ...state
                    }
                default:
                    return state;
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case MAPPING_SET_WIZARD_CLEAR_MAPPING_SET_PREVIEW:
                    return {...state, mappingSetPreview: null, mappingSetPreviewToken: null, updatePreview: false, noMoreResults: false};
                case TRANSCODING_SIMPLE_VALUE_SUBMIT:
                    const newStashWithConstantValue = [...state.stash];
                    const newStashWithConstantValueIdx = newStashWithConstantValue.findIndex(item => item.entityId.toString() === action.mappingId.toString());
                    if (newStashWithConstantValueIdx === -1) {
                        return {
                            ...state,
                        }
                    }
                    newStashWithConstantValue[newStashWithConstantValueIdx] = { ...newStashWithConstantValue[newStashWithConstantValueIdx], ...(Array.isArray(action.response) ? action.response[0] : action.response) };
                    return {
                        ...state,
                        stash: newStashWithConstantValue,
                    }
                case MAPPING_SET_WIZARD_DELETE_MAPPING_SET:
                    return { ...state, saveSuccessful: true }
                case MAPPING_SET_WIZARD_SAVE_MAPPING_SET:
                    if (action.forValidation) {
                        if (action.response) {
                            return { ...state, saveValidationSuccessful: true,
                                selectedMappingSet: prepareMappingSetObject(action.response.mappingSet),
                                name: action.response.mappingSet.name,
                                description: action.response.mappingSet.description,
                                stash: prepareMappingsForTable(action.response.mappingSet.mappings, state.dsd),
                            }
                        }
                        return { ...state, saveValidationSuccessful: true }
                    }
                    if (action.response) {
                        return { ...state, saveSuccessful: true, validateStatusOnExit: action.response.validationMapping }
                    }
                    return { ...state, saveSuccessful: true, validateStatusOnExit: null }
                case MAPPING_SET_WIZARD_GET_MAPPING_SET_PREVIEW:
                    return { ...state, mappingSetPreview: action.response }
                case MAPPING_SET_WIZARD_GET_MAPPING_TOKEN:
                    return { ...state, mappingSetPreview: null, mappingSetPreviewToken: action.response, updatePreview: true, noMoreResults: false }
                case MAPPING_SET_WIZARD_GET_MAPPING_SET:
                    return {
                        ...state,
                        selectedMappingSet: prepareMappingSetObject(action.response),
                        name: action.response.name,
                        description: action.response.description,
                        stash: prepareMappingsForTable(action.response.mappings, state.dsd),
                        saveSuccessful: false
                    }
                case MAPPING_SET_GET_DSD_INFO:
                    const dsdInfo = action.response.data.dataStructures[0];
                    const allComponentsObj = dsdInfo.dataStructureComponents;
                    if (!allComponentsObj) return state;
                    const dsdComponents = [...(allComponentsObj.dimensionList && allComponentsObj.dimensionList.dimensions ? allComponentsObj.dimensionList.dimensions : []).map(dim => ({
                        ...dim,
                        icon: 'bar-chart'
                    })), ...(allComponentsObj.dimensionList && allComponentsObj.dimensionList.timeDimensions ? allComponentsObj.dimensionList.timeDimensions : []).map(tDim => ({
                        ...tDim,
                        icon: 'clock-circle'
                    })), ...(allComponentsObj.attributeList && allComponentsObj.attributeList.attributes ? allComponentsObj.attributeList.attributes : []).map(attr => ({
                        ...attr,
                        icon: 'profile',
                        type: "attribute"
                    })), {
                        ...(allComponentsObj.measureList && allComponentsObj.measureList.primaryMeasure ? allComponentsObj.measureList.primaryMeasure : {}),
                        type: "primaryMeasure",
                        icon: 'line-chart'
                    }]
                    return { ...state, dsd: dsdComponents, dsdTriplet: { id: dsdInfo.id, version: dsdInfo.version, agencyID: dsdInfo.agencyID } };
                case MAPPING_SET_WIZARD_QUERY_PREVIEW_COLUMN_ROWS_READ:
                    if (!action.colName) {
                        return { ...state, colRows: adjustRowsObject(action.response) };
                    }
                    const rows = { ...action.response };
                    const chosenColIdx = rows.columns.findIndex(row => row === action.colName);
                    if (chosenColIdx === -1) {
                        return state;
                    }
                    rows.columns = [action.colName];
                    rows.rows = action.response.rows.map(item => ({ [action.colName]: item[chosenColIdx] }));
                    return { ...state, colRows: rows }
                case MAPPING_SET_WIZARD_QUERY_PREVIEW_ROWS_READ:
                    return { ...state, rows: adjustRowsObject(action.response) };
                case MAPPING_SET_GET_DDB_CONNECTIONS:
                    return { ...state, connections: action.response };
                case MAPPING_SET_GET_DATASETS:
                    return { ...state, datasets: action.response };
                case MAPPING_SET_SELECT_DATASET:
                    return { ...state, selectedDataset: action.response,
                        stash: action.shouldEraseStash ? null : state.stash,
                        components: action.shouldEraseStash ? null : state.components,
                        selectedMapping: action.shouldEraseStash ? null : state.selectedMapping,
                        selectedColumnName: action.shouldEraseStash ? null : state.selectedColumnName,
                        selectedDsdColumnName: action.shouldEraseStash ? null : state.selectedDsdColumnName, }
                case TRANSCODING_SETTINGS_SAVE_DIMENSION:
                    const stashClone = [...state.stash];
                    const newStashWithDimensionIdx = stashClone.findIndex(item => item.entityId.toString() === action.entityId.toString() && item.dsdType.toString() === action.dsdType.toString());
                    if (newStashWithDimensionIdx === -1) {
                        return {
                            ...state,
                        }
                    }
                    stashClone[newStashWithDimensionIdx].transcoding = { ...stashClone[newStashWithDimensionIdx].transcoding, ...action.response };
                    return {
                        ...state,
                        stash: stashClone
                    }
                case TRANSCODING_SETTINGS_DELETE_DIMENSION: {
                    const stashClone = [...state.stash];
                    const newStashWithDimensionIdx = stashClone.findIndex(item => item.entityId.toString() === action.entityId.toString() && item.dsdType.toString() === action.dsdType.toString());
                    if (newStashWithDimensionIdx === -1) {
                        return {
                            ...state,
                        }
                    }
                    stashClone[newStashWithDimensionIdx].transcoding = null;
                    stashClone[newStashWithDimensionIdx].timeTranscoding = null;
                    return {
                        ...state,
                        stash: stashClone
                    }
                }
                case MAPPING_SET_CHECK_STRUVAL:
                    return {
                        ...state,
                        isStruvalPresent: action.response
                    }
                case MAPPING_SET_WIZARD_VALIDATE_FORMAT:
                    return {
                        ...state,
                        validateFormatStatus: action.response
                    }
                case MAPPING_SET_WIZARD_VALIDATE_MAPPING:
                    return {
                        ...state,
                        validateMappingStatus: action.response
                    }
                case MAPPING_SET_WIZARD_VALIDATE_DATA:
                    return {
                        ...state,
                        validateDataStatus: action.response
                    }
                case MAPPING_SET_WIZARD_VALIDATE_DATASET:
                    return {
                        ...state,
                        validateDatasetStatus: action.response
                    }
                default:
                    return state;
            }
        default:
            return state;
    }
}

export default mappingSetWizardReducer;